import { createContext, useContext } from "react";

export const StudioStoryContext = createContext();

export const useStudioStory = () => useContext(StudioStoryContext);
